import { useContext, useRef, useState } from "react";
import { useParams } from "react-router";

// NOTIFICATION COMPONENT
import NotificationMessage, {
  notificationType,
} from "../../../components/NotificationMessage/NotificationMessage";

// REDUX STORE
import { APIContext } from "../../../store/APIStore";
import { StoreContext } from "../../../store/Store";
import { IAttendeeCategory } from "../../../dataProvider/interfaces/IEvent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import { BiEdit, BiTrash } from "react-icons/bi";
import { theme } from "../../../theme";
import {
  actionDialogType,
  Props as dialogType,
} from "../../../components/SimpleActionDialog/SimpleActionDialog";
import SimpleActionDialog from "../../../components/SimpleActionDialog/SimpleActionDialog";
import { category as classes } from "./styles";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";

// COMPONENT INTERFACE
export interface IProps {
  list: Array<IAttendeeCategory>;
}

const CategoryList = ({ list }: IProps) => {
  const { eventId } = useParams() as any;
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);
  const notificationRef = useRef<any>();
  const [confirmationDialog, setConfirmationDialog] = useState<dialogType>({
    open: false,
    title: "",
    type: actionDialogType.REGULAR,
    isLoading: false,
    onConfirm: () => { },
  });

  const handleDialogClose = () => {
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  };

  const onEdit = async (id?: number) => {
    if (id) {
      const item = list.find((each) => each.id === id);
      if (item) {
        dispatch({ type: "SET_ATTENDEE_CATEGORY_ACTION", payload: { type: "EDIT", payload: item } });
      }
    }
  };
  const onDelete = async (id?: number) => {
    if (id) {
      const current: Array<IAttendeeCategory> = state?.attendeeCategoriesList?.list || [];
      const pos = current?.findIndex(each => each.id === id);

      if (pos > -1) {
        try {
          const data = await api.eventService.deleteAttendeeCategory<IAttendeeCategory>(eventId, String(id));
          if (data && data.id) {
            current.splice(pos, 1);
            dispatch({
              type: "SET_ATTENDEE_CATEGORIES_LIST",
              payload: { ...state?.attendeeCategoriesList, list: current }
            });
          }
        } catch (error: any) {
          console.log(error.response);
          notificationRef.current?.show(
            error.response.data.message,
            notificationType.Error
          );
        }
      }
    }
  };

  return (
    <>
      <List>
        {list?.map((item, index) => (
          <ListItem
            key={index}
            sx={[
              classes.listItem,
              {
                backgroundColor: index % 2 ? "#fff" : theme.palette.grey[600],
              },
            ]}
            secondaryAction={
              <Box sx={{ display: "flex", gap: 1 }}>
                <IconButton
                  edge="end"
                  aria-label="category-edit"
                  onClick={() => onEdit(item.id)}
                  size="small"
                >
                  <BiEdit />
                </IconButton>
                <Tooltip
                  placement="top"
                  disableInteractive
                  title={
                    Boolean(item?.count || 0) ? (
                      <span style={{ textAlign: "center", display: "block" }}>
                        This category has <br />
                        attendees associated
                      </span>
                    ) : (
                      ""
                    )
                  }
                >
                  <div>
                    <IconButton
                      edge="end"
                      aria-label="category-delete"
                      disabled={Boolean(item?.count || 0)}
                      onClick={() => onDelete(item.id)}
                      size="small"
                    >
                      <BiTrash />
                    </IconButton>
                  </div>
                </Tooltip>
              </Box>
            }
          >
            <ListItemText
              primary={`${item.name} (${item?.count || 0})`}
              primaryTypographyProps={{
                component: "span",
                fontWeight: "bold",
                fontSize: "16px",
                display: "inline-block",
                mr: 1,
              }}
            />
          </ListItem>
        ))}
      </List>
      {confirmationDialog.open && (
        <SimpleActionDialog
          type={confirmationDialog.type}
          icon={confirmationDialog.icon}
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          isLoading={confirmationDialog.isLoading}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          onClose={handleDialogClose}
          content={confirmationDialog.content}
          confirmLabel={confirmationDialog.confirmLabel}
        />
      )}

      <NotificationMessage ref={notificationRef} />
    </>
  );
};

export default CategoryList;
